export const ALLERGENS_LIST = [
  'Milk',
  'Eggs',
  'Peanuts',
  'Tree Nuts',
  'Fish',
  'Shellfish',
  'Soy',
  'Wheat',
  'Sesame',
  'Mustard',
  'Celery',
  'Lupin',
  'Mollusks',
];

export const NUTRITION_UNIT_VALUES = [
  {
    label: 'Milliliter (ml)',
    value: 'ml',
  },
  {
    label: 'Gram (gm)',
    value: 'g',
  },
];

export const NUTRITIONS_LIST = [
  // {
  //   label: 'Serving Weight',
  //   value: 'servingWeight',
  //   inputType: 'String',
  // },
  {
    label: 'Serving Amount',
    value: 'servingAmount',
    inputType: 'String',
  },
  {
    label: 'Serving Unit',
    value: 'servingUnit',
    inputType: 'Select',
    values: NUTRITION_UNIT_VALUES,
  },
  {
    label: 'Calories',
    value: 'calories',
    inputType: 'Float',
  },
  {
    label: 'Total Fats',
    value: 'fats_total',
    inputType: 'DTO',
  },
  {
    label: 'Saturated Fats',
    value: 'fats_saturated',
    inputType: 'DTO',
  },
  {
    label: 'Trans Fats',
    value: 'fats_trans',
    inputType: 'DTO',
  },
  {
    label: 'Polyunsaturated Fats',
    value: 'fats_polyunsaturated',
    inputType: 'DTO',
  },
  {
    label: 'Monounsaturated Fats',
    value: 'fats_monounsaturated',
    inputType: 'DTO',
  },
  {
    label: 'Cholesterol',
    value: 'cholesterol',
    inputType: 'DTO',
  },
  {
    label: 'Sodium',
    value: 'sodium',
    inputType: 'DTO',
  },
  {
    label: 'Total Carbohydrates',
    value: 'carbohydrates_total',
    inputType: 'DTO',
  },
  {
    label: 'Carbohydrates Fiber',
    value: 'carbohydrates_fiber',
    inputType: 'DTO',
  },
  {
    label: 'Total Carbohydrates Sugar',
    value: 'carbohydrates_sugars_total',
    inputType: 'DTO',
  },
  {
    label: 'Carbohydrates Sugar Added',
    value: 'carbohydrates_sugars_added',
    inputType: 'DTO',
  },
  {
    label: 'Protein',
    value: 'protein',
    inputType: 'DTO',
  },
  {
    label: 'Vitamins',
    value: 'vitamins',
    inputType: 'DTO',
    isMultiple: true,
  },
  {
    label: 'Minerals',
    value: 'minerals',
    inputType: 'DTO',
    isMultiple: true,
  },
  {
    label: 'Glycemic Index',
    value: 'glycemicIndex',
    inputType: 'Float',
  },
];

export const FOOD_ITEM_UNITS = {
  'fruit-juices': ['ml', 'l', 'cup', 'glass', 'bottle', 'can', 'oz'],
  'fruits-and-fruit-juices': ['ml', 'l', 'cup', 'glass', 'bottle', 'can', 'oz'],
  fruits: ['count', 'piece', 'g', 'kg', 'lb', 'cup', 'oz', 'slice'],
  'legumes-and-legume-products': ['can', 'g', 'kg', 'lb', 'cup', 'oz', 'tbsp'],
  'vegetables-and-vegetable-products': ['count', 'head', 'bunch', 'g', 'kg', 'lb', 'cup', 'tbsp', 'jar', 'ml', 'oz'],
  'sausages-and-luncheon-meats': ['count', 'slice', 'link', 'g', 'kg', 'lb', 'pack'],
  'nut-and-seed-products': ['g', 'kg', 'lb', 'cup', 'oz', 'tbsp', 'handful'],
  'egg-products': ['count', 'dozen', 'slice'],
  'dairy-and-egg-products': ['count', 'dozen', 'ml', 'l', 'cup', 'g', 'kg', 'slice', 'stick', 'block', 'tbsp', 'oz'],
  'baked-products': ['slice', 'loaf', 'pack', 'g', 'kg', 'lb', 'piece', 'wrap', 'tortilla', 'serving'],
  'spices-and-herbs': ['tsp', 'tbsp', 'g', 'jar', 'pinch', 'leaf', 'sprig'],
  'fats-and-oils': ['ml', 'l', 'cup', 'bottle', 'tbsp', 'stick', 'g', 'oz'],
  'poultry-products': ['g', 'kg', 'lb', 'count', 'piece', 'fillet'],
  'soups-sauces-and-gravies': ['ml', 'l', 'cup', 'jar', 'can', 'tbsp', 'oz'],
  'finfish-and-shellfish-products': ['g', 'kg', 'lb', 'count', 'oz', 'fillet'],
  'restaurant-foods': ['serving', 'piece', 'plate', 'g', 'oz'],
  'beef-products': ['g', 'kg', 'lb', 'count', 'steak'],
  sweets: ['count', 'pack', 'g', 'oz', 'tbsp', 'jar', 'bottle', 'piece'],
  'pork-products': ['g', 'kg', 'lb', 'link', 'slice', 'count', 'fillet'],
  'cereal-grains-and-pasta': ['g', 'kg', 'lb', 'cup', 'oz', 'packet', 'box'],
};

export const PREPARATION_STATE = [
  { label: 'Fresh', value: 'fresh' },
  { label: 'Dried', value: 'dried' },
  { label: 'Ground', value: 'ground' },
  { label: 'Chopped', value: 'chopped' },
  { label: 'Sliced', value: 'sliced' },
  { label: 'Minced', value: 'minced' },
  { label: 'Crushed', value: 'crushed' },
  { label: 'Grated', value: 'grated' },
  { label: 'Pureed', value: 'pureed' },
  { label: 'Blended', value: 'blended' },
  { label: 'Toasted', value: 'toasted' },
  { label: 'Roasted', value: 'roasted' },
  { label: 'Baked', value: 'baked' },
  { label: 'Steamed', value: 'steamed' },
  { label: 'Fried', value: 'fried' },
  { label: 'Blanched', value: 'blanched' },
  { label: 'Pickled', value: 'pickled' },
  { label: 'Fermented', value: 'fermented' },
  { label: 'Marinated', value: 'marinated' },
  { label: 'Smoked', value: 'smoked' },
  { label: 'Stewed', value: 'stewed' },
  { label: 'Grilled', value: 'grilled' },
  { label: 'Cured', value: 'cured' },
  { label: 'Whisked', value: 'whisked' },
  { label: 'Pounded', value: 'pounded' },
  { label: 'Simmered', value: 'simmered' },
  { label: 'Raw', value: 'raw' },
];
export const RECIPE_CONDITIONS = [
  { label: 'Fresh', value: 'fresh' },
  { label: 'Frozen', value: 'frozen' },
  { label: 'Canned', value: 'canned' },
  { label: 'Pasteurized', value: 'pasteurized' },
  { label: 'Chilled', value: 'chilled' },
  { label: 'Aged', value: 'aged' },
  { label: 'Ripe', value: 'ripe' },
  { label: 'Unripe', value: 'unripe' },
  { label: 'Raw', value: 'raw' },
  { label: 'Processed', value: 'processed' },
  { label: 'Salted', value: 'salted' },
  { label: 'Smoked', value: 'smoked' },
  { label: 'Glazed', value: 'glazed' },
  { label: 'Unpeeled', value: 'unpeeled' },
  { label: 'Peeled', value: 'peeled' },
  { label: 'De-seeded', value: 'de_seeded' },
  { label: 'De-shelled', value: 'de_shelled' },
  { label: 'Crushed', value: 'crushed' },
  { label: 'Sprouted', value: 'sprouted' },
];
